module.exports = __webpack_public_path__ + "assets/img/benefit-3.2e31548d.svg";